enum Paths {
    product = '/products/products',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/Product/paths.ts